import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  twoRows: {
    display: 'grid',
    gridGap: theme.spacing(1),
    justifyContent: 'flex-start',
    fontSize: '0.9rem',
    height: '3.6rem',
  },
}));

export default useStyles;
